import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

interface AddStrongbacksQuestionProps {
  onYes: () => void;
  onNo: () => void;
}

export function AddStrongbacksQuestion({ onYes, onNo }: AddStrongbacksQuestionProps) {
  return (
    <div className="flex flex-col gap-2">
      <Typography variant="text-xl" weight="semibold" className="text-center">
        Do you wish to add strongbacks to design?
      </Typography>
      <div className="flex justify-center gap-2">
        <Button variant="outline" onClick={onNo}>
          No
        </Button>
        <Button onClick={onYes}>Yes</Button>
      </div>
    </div>
  );
}
